import { useContext } from "react";
import HTTPClientContext from "context/httpClientContext";

function useHTTPClient() {
  return useContext(HTTPClientContext);
}

export default useHTTPClient;
